<div class="main-container">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <h1>Welcome to Smardie!</h1>
        <p class="light">In order to get started you'll need to create a new password so we can setup your account.</p>
        <p class="light">Strong passwords are made up of uppercase and lowercase letters, numbers, symbols and spaces.</p>
        <br>

        <app-form-error></app-form-error>

        <form class="verify">
          <div class="field">
            <div class="label">New Password</div>
            <div class="ui fluid left icon input">
              <i class="lock icon"></i>
              <input placeholder="Enter your new password" type="password" v-model="password"
                     v-bind:class="{ error:validation('password') }">
            </div>
          </div>

          <div class="field">
            <div class="label">Confirm New Password</div>
            <div class="ui fluid left icon input">
              <i class="lock icon"></i>
              <input placeholder="Confirm your new password" type="password" v-model="password_confirmation"
                     v-bind:class="{ error:validation('password_confirmation') }">
            </div>
          </div>

          <div class="field">
            <a class="ui fluid primary button" v-on:click.prevent="verify" :class="{ loading: loading }">
              {{ loading ? 'Verifying...' : 'CONFIRM NEW PASSWORD' }}
            </a>
          </div>
        </form>

        <hr>
        <p>Already have an account? <router-link :to="{name: 'Login'}"><a class="primary">Login Now</a></router-link></p>
      </div>
    </div>
  </div>
</div>
